// ===================================================================
// 🔔 COMPONENTE DE SINO DE NOTIFICAÇÕES
// ===================================================================

import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import { styles } from '../../styles/globalStyles';

export const NotificationBell = React.memo(() => {
  const { notifications, markAsRead, removeNotification } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);

  const unreadCount = useMemo(() =>
    notifications.filter(notif => !notif.read).length
  , [notifications]);

  const handleClickOutside = useCallback((event) => {
    if (!event.target.closest('.notification-bell')) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [isOpen, handleClickOutside]);

  const toggleDropdown = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const handleNotificationClick = useCallback((notification) => {
    if (!notification.read) {
      markAsRead(notification.id);
    }
  }, [markAsRead]);

  const handleRemoveNotification = useCallback((event, notificationId) => {
    event.stopPropagation();
    removeNotification(notificationId);
  }, [removeNotification]);

  return (
    <div className="notification-bell" style={{ position: 'relative' }}>
      <button
        onClick={toggleDropdown}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          position: 'relative',
          padding: '8px',
          borderRadius: '50%',
          transition: 'background-color 0.2s'
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#F3F4F6'}
        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
      >
        <span style={{ fontSize: '20px' }}>🔔</span>
        {unreadCount > 0 && (
          <span
            style={{
              position: 'absolute',
              top: '-2px',
              right: '-2px',
              backgroundColor: '#EF4444',
              color: 'white',
              borderRadius: '50%',
              width: '18px',
              height: '18px',
              fontSize: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold'
            }}
          >
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            width: '320px',
            maxHeight: '400px',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
            border: '1px solid #E5E7EB',
            zIndex: 1000,
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              padding: '16px',
              borderBottom: '1px solid #E5E7EB',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
              Notificações
            </h3>
            <span style={{ fontSize: '12px', color: '#6B7280' }}>
              {notifications.length} total
            </span>
          </div>

          <div style={{ maxHeight: '300px', overflow: 'auto' }}>
            {notifications.length === 0 ? (
              <div style={{ padding: '24px', textAlign: 'center', color: '#6B7280' }}>
                Nenhuma notificação
              </div>
            ) : (
              notifications.map(notification => (
                <div
                  key={notification.id}
                  onClick={() => handleNotificationClick(notification)}
                  style={{
                    padding: '16px',
                    borderBottom: '1px solid #F3F4F6',
                    cursor: 'pointer',
                    backgroundColor: notification.read ? 'white' : '#F0F9FF',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#F9FAFB'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = notification.read ? 'white' : '#F0F9FF'}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ 
                        fontWeight: notification.read ? '400' : '600',
                        color: notification.read ? '#6B7280' : '#1F2937',
                        marginBottom: '4px'
                      }}>
                        {notification.title}
                      </div>
                      <div style={{ 
                        fontSize: '14px',
                        color: '#6B7280',
                        marginBottom: '8px'
                      }}>
                        {notification.message}
                      </div>
                      <div style={{ fontSize: '12px', color: '#9CA3AF' }}>
                        {notification.timestamp.toLocaleString('pt-BR')}
                      </div>
                    </div>
                    <button
                      onClick={(e) => handleRemoveNotification(e, notification.id)}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#9CA3AF',
                        fontSize: '16px',
                        padding: '4px',
                        marginLeft: '8px'
                      }}
                    >
                      ×
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}); 